module.exports = __webpack_public_path__ + "img/erc20-tether.9c482405.png";